export default class SceneManager {

	constructor(args) {
		this.system = args.system;	
		this.modules = args.modules;	
		this.currentScene = null;
	}

	changeScene(name, data={}) {
		if(this.currentScene) this.currentScene.destroy();
		requestAnimationFrame(() => {
			this.currentScene = new this.modules[name].default({system:this.system});
			this.currentScene.init(data);
			if(this.system.debug) {
				window.scene = this.currentScene;
			}
		});
	}

	update(delta, deltaNormal) {
		if(this.currentScene) this.currentScene.update(delta, deltaNormal);
	}

	cleanUp() {
		if(this.currentScene) this.currentScene.cleanUp();
	}

}